/*
 * Notification that the user has completed an assignment.
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import BaseToastNotification from "../components/base-toast-notification.tsx";

export default class StripeUpdateSuccessNotification extends React.Component<{
    content: string;
}> {
    render(): React.ReactNode {
        return (
            <BaseToastNotification style={styles.paymentInfo}>
                {this.props.content}
            </BaseToastNotification>
        );
    }
}

const fadeIn = {
    from: {opacity: 0},
    to: {opacity: 1},
} as const;

const styles = StyleSheet.create({
    paymentInfo: {
        background: "#1866f2",
        fontSize: 16,
        color: "#ffffff",
        minWidth: 374,
        minHeight: 44,
        textAlign: "center",
        padding: "3% 7%",
        // @ts-expect-error - TS2322 - Type '{ readonly from: { readonly opacity: 0; }; readonly to: { readonly opacity: 1; }; }' is not assignable to type 'AnimationName | undefined'.
        animationName: fadeIn,
        animationDuration: "500ms",
        animationTimingFunction: "ease-in ease-out",
    },
});
